import { Step } from '../../shared/components/Stepper/Stepper.types'

export const FLIGHT_BOOKING_SUBMISSION_STORAGE_KEY = 'flight_booking_submission'
export const CREATE_FLIGHT_BOOKING_PAYMENT_INTENT_STORAGE_KEY = 'CREATE_FLIGHT_BOOKING_PAYMENT_INTENT'
export const ACCOUNT_SESSION_STORAGE_KEY = 'ACCOUNT_SESSION'
export const FARE_OFFER_STORAGE_KEY = 'FARE_OFFER'
export const FLIGHT_ITINERARY_STORAGE_KEY = 'FLIGHT_ITINERARY'

export const steps: Step[] = [
  { label: 'Choose Flights' },
  { label: 'Passenger and Seat Details' },
  { label: 'Delivery Details' },
  { label: 'Payment' },
  { label: 'Booking Confirmation' }
]

export const stepDetails = {
  chooseFlights: {
    headerTitle: steps[0].label,
    headerSubtitle: 'Select your preferred flight options',
    step: steps[0],
    index: 0
  },
  passengerAndSeatDetails: {
    headerTitle: steps[1].label,
    headerSubtitle: 'Enter passenger information and select seats',
    step: steps[1],
    index: 1
  },
  deliveryDetails: {
    headerTitle: steps[2].label,
    headerSubtitle:
      'Provide delivery address. Items will be delivered to this address x days before your flight to your destination.',
    step: steps[2],
    index: 2
  },
  payment: {
    headerTitle: steps[3].label,
    headerSubtitle: 'Complete your payment',
    step: steps[3],
    index: 3
  },
  bookingConfirmation: {
    headerTitle: steps[4].label,
    headerSubtitle: 'Your booking is confirmed',
    step: steps[4],
    index: 4
  }
}
